import { SummaryOidOffBy } from './SummaryOidOffBy';

export default SummaryOidOffBy;
